import React, { useEffect, useState } from "react";
import Sidebar from "@/components/Sidebar";
import SiteSelector from "@/components/SiteSelector";
import OfflineBadge from "@/components/OfflineBadge";
import DuplicateBanner from "@/components/DuplicateBanner";
import { List } from "@phosphor-icons/react";
import { useLocation } from "react-router-dom";

export default function Shell({ children, title, subtitle, actions, hideSiteSelector = false }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const loc = useLocation();

  // Route değişince mobil menüyü otomatik kapat
  useEffect(() => { setSidebarOpen(false); }, [loc.pathname]);

  // Menü açıkken body scroll'unu kilitle (mobil)
  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [sidebarOpen]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Mobil overlay */}
      {sidebarOpen && (
        <button
          type="button"
          aria-label="Menüyü kapat"
          onClick={() => setSidebarOpen(false)}
          className="lg:hidden fixed inset-0 z-40 bg-black/50 backdrop-blur-sm"
          data-testid="sidebar-overlay"
        />
      )}

      <main className="lg:ml-64 min-h-screen">
        <header className="bg-white border-b border-slate-200 sticky top-0 z-20">
          <div className="px-4 sm:px-6 lg:px-12 py-4 lg:py-6 flex items-center gap-3 lg:gap-6">
            {/* Hamburger — sadece mobil */}
            <button
              type="button"
              onClick={() => setSidebarOpen(true)}
              data-testid="menu-toggle"
              aria-label="Menüyü aç"
              className="lg:hidden -ml-1 p-2 text-slate-700 hover:bg-slate-100 rounded-sm"
            >
              <List size={22} weight="bold" />
            </button>

            <div className="min-w-0 flex-1">
              {subtitle && (
                <div className="text-[10px] sm:text-xs uppercase tracking-[0.2em] font-bold text-slate-500 truncate" data-testid="page-subtitle">
                  {subtitle}
                </div>
              )}
              <h1 className="text-lg sm:text-2xl lg:text-3xl tracking-tight font-bold text-slate-900 font-heading truncate" data-testid="page-title">
                {title}
              </h1>
            </div>

            <div className="flex items-center gap-2 flex-wrap justify-end">
              <OfflineBadge compact />
              {!hideSiteSelector && <SiteSelector />}
              {actions}
            </div>
          </div>
        </header>

        <DuplicateBanner />

        <div className="p-4 sm:p-6 lg:p-12 pb-24 lg:pb-12">{children}</div>
      </main>
    </div>
  );
}
